/**
 * 资源查分析服务
 * 定义接口
 */
const IEMapService = require('./IEMapService');

/**
 * @description 资源分析资源目录
 * @typedef G.service.IResourceAnalysisService~ResourcesCatalog
 * @type Object
 * @property {Object[]} list
 * @property {Object} [list[i]] 资源节点
 * @property {String} list[i].id 资源节点ID
 * @property {String} list[i].name 资源节点名称
 * @property {String} list[i].parentId 资源节点父节点ID
 * @property {Boolean} list[i].isLeaf 是否是叶子节点
 */


/**
 * @description 资源分析查询结果
 * @typedef G.service.IResourceAnalysisService~QueryResult
 * @type Object
 * @property {Number} [radius] 缓冲半径，缓冲查询时为缓冲区半径
 * @property {Integer} total 所有资源总数
 * @property {Object[]} collection 资源结果集合
 * @property {Object} [collection[i]] 每类资源结果
 * @property {String} collection[i].id 资源ID
 * @property {String} collection[i].name 资源名称
 * @property {Object[]} collection[i].list 资源结果列表
 * @property {Object} [collection[i].list[j]] 资源结果列表
 * @property {String} collection[i].list[j].id 资源记录ID
 * @property {GeoJSON} collection[i].list[j].geometry 坐标
 * @property {Number} [collection[i].list[j].distance] 距离，单位米
 */

/**
 * @description 资源分析统计结果
 * @typedef G.service.IResourceAnalysisService~StatisticsResult
 * @type Object
 * @property {Number} [radius] 缓冲半径，缓冲统计时为缓冲区半径
 * @property {Integer} total 所有资源总数
 * @property {Object[]} collection 资源结果集合
 * @property {Object} [collection[i]] 每类资源结果
 * @property {String} collection[i].id 资源ID
 * @property {String} collection[i].name 资源名称
 * @property {Integer} collection[i].total 资源总数
 */

/**
 * @classdesc 资源查分析服务接口
 * @alias G.service.IResourceAnalysisService
 * @augments G.service.IEMapService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 */
class IResourceAnalysisService extends IEMapService {
    constructor(opts) {
        super(opts);
    }

    /**
     * 获取分析的资源目录结构
     * @param {Object} opts
     * @param {String} [opts.eventType] 事故类型
     * @returns {G.service.IResourceAnalysisService~ResourcesCatalog}
     */
    getResourceCatalog(opts) {}

    /**
     * 缓冲查询
     * @param {Object} opts 
     * @param {String[]} opts.resources 资源ID数组
     * @param {GeoJSON} opts.geometry 缓冲的空间要素（如事故点）
     * @param {Number|Number[]} opts.radius 缓冲半径，单位米，多圈缓冲时，则为数组，半径数值依次从小到大
     * @param {String} [opts.eventType] 事件类型 
     * @returns {G.service.IResourceAnalysisService~QueryResult[]} 
     */
    bufferQuery(opts) {}


    /**
     * 自定义范围查询
     * @param {Object} opts 
     * @param {String[]} opts.resources 资源ID数组
     * @param {GeoJSON} opts.geometryFilter 自定义区域
     * @param {GeoJSON} [opts.geometry] 【预留参数】参照空间要素，用于计算距离（如事故点）
     * @param {String} [opts.eventType] 事件类型 
     * @returns {G.service.IResourceAnalysisService~QueryResult}
     */
    polygonQuery(opts) {}

    /**
     * 关键字查询
     * @param {Object} opts 
     * @param {String[]} opts.resources 资源ID数组
     * @param {String} opts.keyword 关键字
     * @param {GeoJSON} [opts.geometry] 【预留参数】参照空间要素，用于计算距离（如事故点）
     * @param {String} [opts.eventType] 事件类型 
     * @returns {G.service.IResourceAnalysisService~QueryResult}
     */
    keywordQuery(opts) {}

    /**
     * 行政区划查询
     * @param {Object} opts 
     * @param {String[]} opts.resources 资源ID数组
     * @param {String[]} opts.districtCode 行政区划编码数组
     * @param {Integer} opts.strategy 【预留参数】查询策略，1=按行政区划字段，2=按行政区划边界；默认为1
     * @param {GeoJSON} [opts.geometry] 【预留参数】参照空间要素，用于计算距离（如事故点）
     * @param {String} [opts.eventType] 事件类型 
     * @returns {G.service.IResourceAnalysisService~QueryResult}
     */
    districtQuery(opts) {}


    /**
     * 缓冲区统计【预留接口暂未实现】
     * @param {Object} opts 
     * @param {String[]} opts.resources 资源ID数组
     * @param {GeoJSON} opts.geometry 缓冲的空间要素（如事故点）
     * @param {Number|Number[]} opts.radius 缓冲半径，单位米，多圈缓冲时，则为数组，半径数值依次从小到大
     * @param {String} [opts.eventType] 事件类型 
     * @returns {G.service.IResourceAnalysisService~StatisticsResult[]}
     */
    bufferStatistics(opts) {

    }

    /**
     * 自定义范围统计【预留接口暂未实现】
     * @param {Object} opts 
     * @param {String[]} opts.resources 资源ID数组
     * @param {GeoJSON} opts.geometryFilter 自定义区域
     * @param {String} [opts.eventType] 事件类型 
     * @returns {G.service.IResourceAnalysisService~StatisticsResult}
     */
    polygonStatistics(opts) {}

    /**
     * 关键字统计【预留接口暂未实现】
     * @param {Object} opts 
     * @param {String[]} opts.resources 资源ID数组
     * @param {String} opts.keyword 关键字
     * @param {String} [opts.eventType] 事件类型 
     * @returns {G.service.IResourceAnalysisService~StatisticsResult}
     */
    keywordStatistics(opts) {

    }


    /**
     * 行政区划统计【预留接口暂未实现】
     * @param {Object} opts 
     * @param {String[]} opts.resources 资源ID数组
     * @param {String[]} opts.districtCode 行政区划编码数组
     * @param {Integer} opts.strategy 【预留参数】查询策略，1=按行政区划字段，2=按行政区划边界；默认为1
     * @param {String} [opts.eventType] 事件类型 
     * @returns {G.service.IResourceAnalysisService~StatisticsResult}
     */
    districtStatistics(opts) {

    }

}
module.exports = IResourceAnalysisService;